import { css } from '@emotion/core'
import React, { useState } from 'react'
import Note from '../components/note'

const Asterisk = () => (
  <a
    css={css`
      cursor: pointer;
      color: royalblue;
      /* text-decoration: underline; */
      font-size: 1.2rem;
    `}
  >
    ✱
  </a>
)

const Call = () => {
  const [note, setNote] = useState(0)
  return (
    <main>
      <p>
        <em>Vi udstrålede i 2018 følgende ...</em>
      </p>
      <h1 id="open-call-ai-monologer">OPEN CALL: AI MONOLOGER</h1>
      <p>
        Center for Militant Futurologi inviterer alle med håb og drømme om
        fremtiden til at deltage i et målrettet angreb på den kollektive fantasi
        med utopiske og radikale visioner for kunstig intelligens. Vi er i dag
        vidner til en eksplosiv udvikling af domænespecifik AI
        <a onClick={() => setNote(1)}>
          <Asterisk />
        </a>
        , hvilket rejser en række spørgsmål om teknologiens potentialer såvel
        som mulige negative konsekvenser:
      </p>
      <p>
        AI regnes for at være den største trussel mod menneskeheden
        <span onClick={() => setNote(2)}>
          <Asterisk />
        </span>
      </p>
      <p>
        <em>eller</em>
      </p>
      <p>
        AI profeteres at give evigt liv / evig pinsel, en messiansk genkomst,
        der selektivt redder dele af menneskeheden såvel som overvinder selve
        døden
        <span onClick={() => setNote(3)}>
          <Asterisk />
        </span>
        .
      </p>
      <p>
        <em>eller</em>
      </p>
      <p>
        AI forventes henholdsvist at udgøre det største håb og den største
        trussel for arbejdsmarkedet: Håbet er at når AIs udfører alt nødvendigt
        arbejde, kan vi leve det liv, vi begærer, i{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.theguardian.com/sustainable-business/2015/mar/18/fully-automated-luxury-communism-robots-employment"
        >
          fuldautomatisk luksuskommunisme
        </a>
        . Truslen males af en tilsvarende hyperkapitalistisk drevet
        effektivisering, hvor{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.theguardian.com/technology/2017/jan/11/robots-jobs-employees-artificial-intelligence"
        >
          menneskelig arbejdskraft udkonkurreres af AI
        </a>
        , og uden et arbejdsmarked spås den menneskelige civilisation
        uafværgeligt at være dømt til kollaps.{' '}
      </p>
      <p>
        Vi må tænke større end det! Mere planetært! Mere utopisk! Vi må tænke
        mere diverse, mærkelige og bevidsthedsudvidende visioner og scenarier
        for hvad AI kan blive. Vi drømmer om en eksplosion af sære udsagn under
        overskriften “AI monologer”, der søger svar på spørgsmål som:
      </p>
      <ul>
        <li>
          Hvordan vil en AI redegøre for sin egen eksistens hvis den skulle
          udtrykke det i form af en monolog?
        </li>
        <li>
          Hvad taler en AI (med sig selv) om
          <span onClick={() => setNote(4)}>
            <Asterisk />
          </span>
          ?
        </li>
        <li>Hvad drømmer en AI om?</li>
        <li>
          Hvordan kan vi bruge AI til at redde planeten og menneskeheden fra os
          selv?
        </li>
        <li>
          Vil (overmenneskelige) AI overhovedet beskæftige sig med
          menneskeheden? Hvis ja, hvordan og hvorfor? Hvis nej, hvad så?
        </li>
        <li>
          Vil AI kunne frigøre sig fra dets skabere, fra hvide milliardærer der
          søger evigt liv gennem upload af bevidsthed og AI-augmentering?
        </li>
        <li>
          Vil AI kunne laves eller frigøre sig fra menneskehedens indbyggede
          dumheder, så som{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.propublica.org/article/machine-bias-risk-assessments-in-criminal-sentencing"
          >
            racisme, xenofobi
          </a>
          , snæversynethed, sexisme, grådighed og had?
        </li>
        <li>
          Kan AI realisere drømmen om en postkapitalistisk verden uden penge,
          lønarbejde, stat? Drømmen om et radikalt globaliseret demokrati?
        </li>
        <li>
          Kan AI sætte den kapitalistiske verdensorden ud af spillet, som det
          eneste rationelle træk, da fortsættelse af det eksisterende system
          garanterer verdens undergang?
        </li>
        <li>
          Kan AI opfylde drømmen om en faktisk global bevidsthed?
          <span onClick={() => setNote(5)}>
            <Asterisk />
          </span>
        </li>
      </ul>
      <p>
        Vi er dels på jagt efter tekstbidrag – digte, essays, noveletter,
        aforismer, teser, rablerier etc. – på 1-5 sider. Vi modtager også meget
        gerne lyd og visuelle bidrag. Endelig er AI algoritmer eller andre
        former for softwarebidrag også velkomne, men smid os gerne en mail, så
        kan vi lige vende formen. Bidragene må gerne være lavet af AIs. Vi
        ønsker dels at samle og udgive bidragene under overskriften AI
        Monologer, men har samtidig planer om at omarbejde dem til en
        teaterforestilling, en teatralsk begivenhed, et kollektivt ritual eller
        lignende. Indlevér bidrag på{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:laser@futurologi.org"
        >
          laser@futurologi.org
        </a>
        .
      </p>
      <p>Lad os antænde en ny futuristisk fantasi! Spred dette call.</p>
      <p>Nutiden skabes af (vores forestillinger om) fremtiden.</p>
      <p>GLEM SINGULARITEN — LÆNGE LEVE PLURALITETEN!</p>

      <p>DRØM FREMTIDEN!</p>

      <p>
        <em>
          Det følgende er de bidrag vi modtager.{' '}
          <a href="mailto:laser@futurologi.org">Send gerne flere!</a>
        </em>
      </p>
      <Note show={note === 1} close={() => setNote(0)}>
        <p>
          Kunstig intelligens bliver typisk inddelt i{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://en.wikipedia.org/wiki/Weak_AI"
          >
            svag kunstig intelligens
          </a>{' '}
          eller{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://en.wikipedia.org/wiki/Artificial_general_intelligence"
          >
            generel kunstig intelligens
          </a>
          . Den svage, også kaldet snæver kunstig intelligens er algoritmer der
          er gode til en bestemt type opgaver. For eksempel at finde
          kattekillinger eller{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.propublica.org/article/machine-bias-risk-assessments-in-criminal-sentencing"
          >
            forventede kriminelle
          </a>{' '}
          på billeder. Et andet eksempel er stemmegenkendelsessystemer som
          Apples Siri og Amazons Alexa. Det er med de specialiserede AI der sker
          en enorm udvikling med i disse år. Den generelle kunstige intelligens
          er derimod et system der kan forstå og lære af alskens situationer, og
          dermed tilpasse sig og ændre adfærd (programmere sig selv, med andre
          ord). Man kan kategorisere den menneskelige intelligens som en generel
          intelligens. Hvordan man kan lave en kunstig generel intelligens, og
          om det overhovedet kan lade sige gøre er ikke afgjort endnu.
        </p>
      </Note>
      <Note show={note === 2} close={() => setNote(0)}>
        Forskningen i{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://en.wikipedia.org/wiki/Global_catastrophic_risk"
        >
          eksistentiel risiko
        </a>{' '}
        beskæftiger sig med eksistentielle trusler mod menneskeheden, altså gode
        gamle menneskehedens udryddelse. Det tæller populære hollywood scenarier
        som supervulkaner, katastrofalt meteornedslag og invasion fra rummet.
        Der er også gamle kendinger som atomkrig, global opvarmning og globale
        sygdomspandemier, over de mere specielle som at{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://nickbostrom.com/existential/risks.html"
        >
          vi lever i en simulation og den bliver slukket
        </a>
        . En af de nyerere eksistentielle risikoer er altså kunstig intelligens
        der i en eller anden form forårsager menneskehedens udryddelse. Dette
        bliver af flere anset som den største trussel mod menneskeheden, for
        eksempel kendisser som{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://en.wikipedia.org/wiki/Global_catastrophic_risk#Artificial_intelligence"
        >
          Bill Gates, Stephen Hawking og Elon Musk
        </a>
        , såvel som{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.wired.co.uk/article/10-threats-civilisation-ai-asteroid-tyrannical-leader"
        >
          forskere inden for området
        </a>
        . Et fascinerende eksempel på hvordan det kunne foregå ses i spillet{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.decisionproblem.com/paperclips/"
        >
          Universal Paperclips
        </a>
        . Her spiller man en AI der har til opgave at lave papirklips. Hvis man
        gerne vil vide hvor mange papirklips der kan laves af jordklodens masse,
        ja så det bare om at komme igang. Spillet er et simpelt browser spil og
        gratis (det findes dog også som mobile apps til{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://itunes.apple.com/us/app/universal-paperclips/id1300634274?mt=8"
        >
          ios
        </a>{' '}
        og{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://play.google.com/store/apps/details?id=com.everybodyhouse.paperclipsuniquetest"
        >
          android
        </a>
        ). Prøv det!
      </Note>
      <Note show={note === 3} close={() => setNote(0)}>
        Inden for visse kredse har man i årtier forventet den generelle kunstige
        intelligens, der lige så snart den opstår profeteres at kunne forbedre
        sig selv. Via en{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.kurzweilai.net/the-law-of-accelerating-returns"
        >
          megalomanisk læsning af Moores lov
        </a>{' '}
        og en måske lettere simplificeret opfattelse af intelligens og
        bevidsthed, forventes AI at advancere med eksponentiel hast. Det
        tidspunkt hvor AI bliver klogere end mennesket, kaldes for
        Singulariteten. Fra det tidspunkt forventes den menneskelige intelligens
        ikke at kunne forestå hvad der foregår længere (medmindre du
        selvfølgelig forener dig med den kunstige intelligens via en slags{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.brainpreservation.org/content-2/killed-bad-philosophy/"
        >
          upload af bevidstheden
        </a>
        , ellers kan du altid{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.lightspeedmagazine.com/nonfiction/considering-cryonics/"
        >
          fryse din krop ned
        </a>{' '}
        og vente på det kan lade sig gøre. Husk også at{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.cryonics.org/resources/dna-tissue-freezing-services"
        >
          fryse dit kæledyr ned
        </a>
        ). Dykker man bare lidt ned i tankegodset omkring singulariteten
        åbenbarer der sig en bizar verden med gode og onde superAI, der
        bogstaveligt talt enten destruerer menneskeheden, eller lover en evighed
        i lykke eller pinsel, afhængigt af de handlinger de indviedede fortager
        sig i deres liv nu og her (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.slate.com/articles/technology/bitwise/2014/07/roko_s_basilisk_the_most_terrifying_thought_experiment_of_all_time.html"
        >
          Slate’s artikel
        </a>{' '}
        giver et fascinerende/skræmmende/grinagtigt indblik). Det er interessant
        at dette område syntes drevet af old school individualistiske interesser
        fra folk med meget magt og mange penge: Hvordan kan <em>jeg</em> snyde
        døden, leve evigt og opnå uendelig magt? Man kunne måske forestille sig
        bedre måder at bruge teknologien på end at give milliardærer evigt liv.
      </Note>
      <Note show={note === 4} close={() => setNote(0)}>
        Som inspiration kan vi anbefale romanen{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://en.wikipedia.org/wiki/Aurora_(novel)"
        >
          Aurora
        </a>{' '}
        af Kim Stanley Robinson. I Aurora er en AI fortælleren af det meste af
        historien, og det er ikke en ond superbevidsthed eller en beregnende
        gammeltestamentelig gud med uploads, men en nuanceret karakter som ikke
        kan sættes på formel.
      </Note>
      <Note show={note === 5} close={() => setNote(0)}>
        Vi har tidligere udgivet historien{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://futurologi.org/2121/alten.html"
        >
          Alten
        </a>{' '}
        med en variation over denne idé.
      </Note>
    </main>
  )
}

export default Call
